// No margin utility class on this <p> — see the base-layer note in
// ReferralForm/styles/index.scss if Magnolia margin ever leaks in here.
function RamseyAgreementText() {
  return (
    <p
      className="text-gray-60 text-1 leading-lg text-left"
      data-testid="ramsey_agreement_text"
    >
      By providing your phone and email and selecting Text Me or Call Me, you
      agree to be contacted by Ramsey Solutions via email, phone, and/or texts,
      and to the use of an automatic telephone dialing system, artificial or
      prerecorded voice, and/or AI-generated messages to advertise and provide
      services to you. You also agree to our{' '}
      <a
        className="text-gray-60 text-1 leading-lg  hover:text-gray-90"
        href="https://www.ramseysolutions.com/company/policies/privacy-policy"
        target="_blank"
        data-testid="privacy_policy_link"
      >
        Privacy{'\u00A0'}Policy
      </a>{' '}
      and{' '}
      <a
        className="text-gray-60 text-1 leading-lg hover:text-gray-90"
        href="https://www.ramseysolutions.com/company/policies/terms-of-use"
        target="_blank"
        data-testid="terms_of_use_link"
      >
        Terms{'\u00A0'}of{'\u00A0'}Use
      </a>
      {''}. Messaging and data rates may apply. Frequency varies.
      <br></br>
      <br></br>
      You may opt out at any time, including by replying STOP to our texts.
      Consent isn't required for products or services from Ramsey Solutions.
      However, opting out may impact your experience with the service(s) that
      rely on communication via calls and texts.
    </p>
  );
}

export { RamseyAgreementText };
